
<template>
  <!-- eslint-disable -->
  <svg :style="style" :class="classes" data-components="LogoXingSvg" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 24"><path fill="#fff" fill-rule="evenodd" d="M17.524 0c-.135 0-.525.15-.705.705l-7.755 13.41c-.135.135-.135.27 0 .405l4.935 8.775c.27.51.435.705.705.705h3.525c.405 0 .975-.18.705-.705l-4.995-8.775c-.135-.135-.135-.27 0-.405L21.514.705c.135-.27-.195-.705-.465-.705h-3.525zM2.449 3.525c-.42 0-.57.195-.15 1.035l2.43 4.47c.135.135.135.27 0 .405L.604 16.77c-.255.45-.045.87.675.885h3.525c.3-.015.555-.345.705-.705l4.23-7.38c.135-.135.135-.27 0-.405l-2.82-4.92c-.18-.405-.285-.69-.705-.705h-3.78l.015-.015z" clip-rule="evenodd"/></svg>
</template>

<script>
import globalMixin from 'Libs/mixins/globalMixin';

export default {
  name: 'LogoXingSvg',
  mixins: [globalMixin],
  props: {
    width: {
      type: [String, Number, Boolean],
      default: false
    },
    height: {
      type: [String, Number, Boolean],
      default: false
    },
    original: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    style() {
      const style = {};

      if (this.width) {
        style.width = this.width + 'px';
      }

      if (this.height) {
        style.height = this.height + 'px';
      }

      return style;
    }
  }
};
</script>
